import LockEventDialog from "./LockEventDialog";
import AddEventDialog from "./AddEventDialog";
import AddShiftDialog from "./AddShiftDialog";
import AddJobDialog from "./AddJobDialog";

function EventManagerDialogs({
  dialogs,
  actions,
  templates,
  selectedSchoolyear,
  shifts,
}) {
  return (
    <>
      {/* LOCK */}
      <LockEventDialog
        open={dialogs.lockDialogOpen}
        onClose={() => dialogs.setLockDialogOpen(false)}
        onConfirm={actions.handleToggleLock}
      />

      {/* EVENT */}
      <AddEventDialog
        open={dialogs.createEventOpen}
        onClose={() => {
          dialogs.setCreateEventOpen(false);
          dialogs.setEditingEvent(null);
        }}
        onSave={(data) =>
          actions.handleSaveEvent(
            data,
            dialogs.editingEvent,
            dialogs.closeEventDialog, // ✅ pass this
          )
        }
        templates={templates}
        selectedSchoolyear={selectedSchoolyear}
        initialData={dialogs.editingEvent}
      />

      {/* SHIFT */}
      <AddShiftDialog
        open={dialogs.createShiftOpen}
        onClose={() => {
          dialogs.setCreateShiftOpen(false);
          dialogs.setEditingShift(null);
        }}
        onSave={(data) => actions.handleSaveShift(data, dialogs.editingShift)}
        initialData={dialogs.editingShift}
      />

      {/* JOB */}
      <AddJobDialog
        open={dialogs.createJobOpen}
        onClose={() => {
          dialogs.setCreateJobOpen(false);
          dialogs.setEditingJob(null);
        }}
        onSave={(data) => actions.handleSaveJob(data, dialogs.editingJob)}
        shifts={shifts}
        initialData={dialogs.editingJob}
      />
    </>
  );
}

export default EventManagerDialogs;
